/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../../routes/__root'
import { Route as IndexRouteImport } from './../../routes/index'
import { Route as DashboardRouteImport } from './../../routes/_dashboard'
import { Route as SigninRouteImport } from './../../routes/_signin'
import { Route as SigninLoginRouteImport } from './../../routes/_signin/login'
import { Route as DashboardDashboardIndexRouteImport } from './../../routes/_dashboard/dashboard.index'
import { Route as DashboardDashboardHistoryRouteImport } from './../../routes/_dashboard/dashboard.history'
import { Route as SigninRegionUrlCodeRouteImport } from './../../routes/_signin/$region.$urlCode'
import { Route as SigninRegionSsoUrlCodeRouteImport } from './../../routes/_signin/$region.sso.$urlCode'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/_signin',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninLoginRoute = SigninLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => SigninRoute,
} as any)
const DashboardDashboardIndexRoute = DashboardDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardDashboardHistoryRoute =
  DashboardDashboardHistoryRouteImport.update({
    id: '/dashboard/history',
    path: '/dashboard/history',
    getParentRoute: () => DashboardRoute,
  } as any)
const SigninRegionUrlCodeRoute = SigninRegionUrlCodeRouteImport.update({
  id: '/$region/$urlCode',
  path: '/$region/$urlCode',
  getParentRoute: () => SigninRoute,
} as any)
const SigninRegionSsoUrlCodeRoute = SigninRegionSsoUrlCodeRouteImport.update({
  id: '/$region/sso/$urlCode',
  path: '/$region/sso/$urlCode',
  getParentRoute: () => SigninRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof SigninLoginRoute
  '/dashboard/history': typeof DashboardDashboardHistoryRoute
  '/$region/$urlCode': typeof SigninRegionUrlCodeRoute
  '/dashboard/': typeof DashboardDashboardIndexRoute
  '/$region/sso/$urlCode': typeof SigninRegionSsoUrlCodeRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof SigninLoginRoute
  '/dashboard/history': typeof DashboardDashboardHistoryRoute
  '/$region/$urlCode': typeof SigninRegionUrlCodeRoute
  '/dashboard': typeof DashboardDashboardIndexRoute
  '/$region/sso/$urlCode': typeof SigninRegionSsoUrlCodeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_dashboard': typeof DashboardRouteWithChildren
  '/_signin': typeof SigninRouteWithChildren
  '/_signin/login': typeof SigninLoginRoute
  '/_dashboard/dashboard/history': typeof DashboardDashboardHistoryRoute
  '/_signin/$region/$urlCode': typeof SigninRegionUrlCodeRoute
  '/_dashboard/dashboard/': typeof DashboardDashboardIndexRoute
  '/_signin/$region/sso/$urlCode': typeof SigninRegionSsoUrlCodeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/dashboard/history'
    | '/$region/$urlCode'
    | '/dashboard/'
    | '/$region/sso/$urlCode'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/dashboard/history'
    | '/$region/$urlCode'
    | '/dashboard'
    | '/$region/sso/$urlCode'
  id:
    | '__root__'
    | '/'
    | '/_dashboard'
    | '/_signin'
    | '/_signin/login'
    | '/_dashboard/dashboard/history'
    | '/_signin/$region/$urlCode'
    | '/_dashboard/dashboard/'
    | '/_signin/$region/sso/$urlCode'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  SigninRoute: typeof SigninRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_signin': {
      id: '/_signin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_signin/login': {
      id: '/_signin/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof SigninLoginRouteImport
      parentRoute: typeof SigninRoute
    }
    '/_dashboard/dashboard/': {
      id: '/_dashboard/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardDashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/history': {
      id: '/_dashboard/dashboard/history'
      path: '/dashboard/history'
      fullPath: '/dashboard/history'
      preLoaderRoute: typeof DashboardDashboardHistoryRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_signin/$region/$urlCode': {
      id: '/_signin/$region/$urlCode'
      path: '/$region/$urlCode'
      fullPath: '/$region/$urlCode'
      preLoaderRoute: typeof SigninRegionUrlCodeRouteImport
      parentRoute: typeof SigninRoute
    }
    '/_signin/$region/sso/$urlCode': {
      id: '/_signin/$region/sso/$urlCode'
      path: '/$region/sso/$urlCode'
      fullPath: '/$region/sso/$urlCode'
      preLoaderRoute: typeof SigninRegionSsoUrlCodeRouteImport
      parentRoute: typeof SigninRoute
    }
  }
}

interface DashboardRouteChildren {
  DashboardDashboardHistoryRoute: typeof DashboardDashboardHistoryRoute
  DashboardDashboardIndexRoute: typeof DashboardDashboardIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardDashboardHistoryRoute: DashboardDashboardHistoryRoute,
  DashboardDashboardIndexRoute: DashboardDashboardIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

interface SigninRouteChildren {
  SigninLoginRoute: typeof SigninLoginRoute
  SigninRegionUrlCodeRoute: typeof SigninRegionUrlCodeRoute
  SigninRegionSsoUrlCodeRoute: typeof SigninRegionSsoUrlCodeRoute
}

const SigninRouteChildren: SigninRouteChildren = {
  SigninLoginRoute: SigninLoginRoute,
  SigninRegionUrlCodeRoute: SigninRegionUrlCodeRoute,
  SigninRegionSsoUrlCodeRoute: SigninRegionSsoUrlCodeRoute,
}

const SigninRouteWithChildren =
  SigninRoute._addFileChildren(SigninRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRouteWithChildren,
  SigninRoute: SigninRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
